import React from "react";
import styled from "styled-components";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";

const StyledSection = styled.section`
  width: 132px;
  height: 180px;
  border-radius: 5px;
  margin-left: 8px;
  margin-right: 8px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  text-align: center;

  p.title {
    margin-bottom: -4px;
    margin-top: 0px;
    font-weight: 500;
  }

  .measurementProgress {
    padding: 4px;
    text-align: justify;

    .alignLeft {
      float: left;
    }
    .alignRight {
      float: right;
    }
    .clearFix {
      clear: both;
    }
  }
`;

export interface CameraMeasurementsProps {
  measurements: {
    density: number;
    flow: number;
    mood: number;
  };
  maxMeasurements: {
    maxDensity: number;
    maxFlow: number;
    maxMood: number;
  };
  timestamp: Date;
}

//Layout is determined here
const CameraMeasurements: React.FC<CameraMeasurementsProps> = props => {
  //TESTING
  const { density, flow, mood } = props.measurements;
  const { maxDensity, maxFlow, maxMood } = props.maxMeasurements;
  const values = [
    { title: "Density", value: density, max: maxDensity },
    { title: "Flow", value: flow, max: maxFlow },
    { title: "Mood", value: mood, max: maxMood },
  ];

  return (
    <>
      <StyledSection>
        {/* <Typography variant="h6">{props.timestamp.toLocaleString()}</Typography> */}
        <p className="title">{props.timestamp.toLocaleString("en")}</p>
        {values.map((v, k) => (
          <div className="measurementProgress">
            <div className="measurementTitle">
              <p className="alignLeft">{v.title}</p>
              <p className="alignRight">
                {v.value ? v.value.toFixed(2) : "--"}
              </p>
              <div className="clearFix"></div>
            </div>
            <LinearProgress
              className="progressBar"
              variant="determinate"
              value={(v.value / v.max) * 100}
            ></LinearProgress>
          </div>
        ))}
      </StyledSection>
    </>
  );
};

export default CameraMeasurements;
